"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsContext = void 0;
const React = require("react");
/**
 * Provides product list and information about the virtual delivery product if available
 */
exports.ProductsContext = React.createContext({
    products: undefined,
    deliveryProduct: undefined,
    serviceProduct: undefined
});
//# sourceMappingURL=index.js.map